import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Tag } from 'antd';

interface AbsenceTagProperties {
    status: boolean;
}

const AbsenceTag: React.FC<AbsenceTagProperties> = ({ status }) => {
    return (
        <Tag color={status ? 'orange' : 'green'} >
            <FormattedMessage id={'general.tag.' + (status ? 'absent' : 'present')} />
        </Tag>
    );
};

export default AbsenceTag;
